/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["footer-bar[_ngcontent-%COMP%]{position:fixed;left:0;bottom:0;width:100%}.m-wrapper[_ngcontent-%COMP%]{margin-bottom:75px}\n/*# sourceMappingURL=theme3-layout.component.css.map*/"];
export { styles as styles };
